import { Component, Input } from '@angular/core';
import { AppScreen, AppBlock } from '../../providers/config/config';
import { AppState } from '../../config/state';
import { Events, MenuController, PopoverController } from 'ionic-angular';
import { CoIframeComponent } from '../co-iframe/co-iframe';

/**
 * Generated class for the CoFooterBlockComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-footer-block',
  templateUrl: 'co-footer-block.html'
})
export class CoFooterBlockComponent {
  @Input() block: AppBlock;
  iframePopover: any;
  constructor(private state : AppState, private events : Events, private menuCtrl : MenuController, private popoverCtrl : PopoverController) {
  }

  ngAfterViewInit(): void {
    // console.log(this.block);
  }

  openIframeMenu(){
    if (this.iframePopover) {
      this.iframePopover.dismiss().catch(err=>{});
      this.iframePopover = null;
      return
    }
    // this.menuCtrl.toggle('sideIframeMenu');
    // this.events.publish('sendIframeLink', this.block.settings);
    this.iframePopover = this.popoverCtrl.create(CoIframeComponent, {block: this.block, classString: `co-iframe-popover ${this.state.currentScreen.menuWidth? this.state.currentScreen.menuWidth : ''} ${this.state.currentScreen.menuSide? this.state.currentScreen.menuSide : 'right'}`}, {cssClass: `co-iframe-popover ${this.state.currentScreen.menuWidth? this.state.currentScreen.menuWidth : 'large'} ${this.state.currentScreen.menuSide? this.state.currentScreen.menuSide : 'right'} ${this.state.currentScreen.menuSide && this.state.currentScreen.menuSide === 'left'? 'slideInLeft' : 'slideInRight'}`});

    this.iframePopover.present({animate: false});

    this.iframePopover.onDidDismiss(data =>{
      this.iframePopover = null;
    });
  }

  showHelp(){
  }

}



// WEBPACK FOOTER //
// ./src/components/co-footer-block/co-footer-block.ts